export default __webpack_public_path__ + "static/media/icon-portis.b673743d.svg";